import { render, staticRenderFns } from "./ClaimDropoff.vue?vue&type=template&id=08c1b0da&"
import script from "./ClaimDropoff.vue?vue&type=script&lang=js&"
export * from "./ClaimDropoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports